<template>
  <div>
    <img
      :src="require('@/assets/images/Group 2419.svg')"
      alt="イベント申込済"
      class="company-source-label mt-2"
    />
  </div>
</template>

<script>
export default {
  name: 'EventParticipation',
};
</script>

<style scoped></style>
